const SEO = [
	{
		page: "home",
		description:
			"I'm Xinwen, a Ph.D. student specializing in bioimaging and image processing. My passion lies in capturing beautiful images of biological samples and using advanced data science techniques to analyze them. Unraveling interesting biological information from these images fuels my excitement as it offers valuable insights into human diseases and drug discovery.",
		keywords: ["Xinwen", "Xinwen Liu"],
	},

	{
		page: "about",
		description:
			"Hi, I'm Xinwen, a Ph.D. student specializing in bioimaging and image processing. My passion lies in capturing beautiful images of biological samples and using advanced data science techniques to analyze them. Unraveling interesting biological information from these images fuels my excitement as it offers valuable insights into human diseases and drug discovery.",
		keywords: ["Xinwen", "Xinwen Liu"],
	},

	{
		page: "articles",
		description:
			"",
		keywords: ["Xinwen", "Xinwen Liu"],
	},

	{
		page: "projects",
		description:
			"Supervised Learning and Anomaly Detection of Large-scale Imaging Data for Drug Discovery.",
		keywords: ["Xinwen", "Xinwen Liu"],
	},

	{
		page: "contact",
		description:
			"If you're interested in collaborating on a project, feel free to reach out to me. I'm always open to new ideas and opportunities.",
		keywords: ["Xinwen", "Xinwen Liu"],
	},
];

export default SEO;
